import { render, staticRenderFns } from "./shoe-brand.vue?vue&type=template&id=4c269476&scoped=true"
import script from "./shoe-brand.vue?vue&type=script&lang=js"
export * from "./shoe-brand.vue?vue&type=script&lang=js"
import style0 from "./shoe-brand.vue?vue&type=style&index=0&id=4c269476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c269476",
  null
  
)

export default component.exports